import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RangePaginationState } from 'components/basic/Pagination';
import StageActionToolbar from '../generic/StageActionToolbar';

import '../../../../../styles/Icons.scss';

interface PolicyDetailsGeneralLiabilityStagingPageArgs {
    conversionId: string,
}

type PolicyDetailsGeneralLiabilityStagingPageProps = RouteComponentProps<PolicyDetailsGeneralLiabilityStagingPageArgs>;

interface PolicyDetailsGeneralLiabilityStagingPageState {
    destinationCodes: any;
    filter: string;

    pagination: RangePaginationState;
}

export class PolicyDetailsGeneralLiabilityStagingPage extends React.Component<PolicyDetailsGeneralLiabilityStagingPageProps, PolicyDetailsGeneralLiabilityStagingPageState>{

    constructor(props: PolicyDetailsGeneralLiabilityStagingPageProps) {
        super(props)
        this.state = {
            destinationCodes: [],
            filter: '',

            pagination: {
                pageSize: 25,
                pageNumber: 0,
            }
        }
    }

    componentDidMount() {
        //this.client.get(this.props.match.params.conversionId, '')
        //    .then((response) => {
        //        this.setState({
        //            items: response!
        //        })
        //    })
        //    .catch(error => { })
    }

    public render() {
        const conversionId = this.props.match.params.conversionId;
        return (
            <>
                <StageActionToolbar
                    conversionId={conversionId}
                    sectionId='generalliability'
                    tierGate='tier4'
                    noMapping={true}
                    filter={this.state.filter}
                />
               
            </>
        );
    }
}